<ng-container>
  <div *ngIf="root && item.visible !== false" class="layout-menuitem-root-text">
    {{ item.label }}
  </div>
  <a
    *ngIf="root && !item.items && item.routerLink && single"
    [routerLink]="!item.disabled ? item.routerLink : null"
    routerLinkActive="bg-primary"
    [routerLinkActiveOptions]="{ exact: !item.preventExact }"
    [attr.target]="item.target"
    pRipple
  >
    
    <app-menu-icons [iconLabel]="item.label"></app-menu-icons>
    <span class="layout-menuitem-text">{{ item.label }}</span>
    <span class="menuitem-badge" *ngIf="item.badge">{{ item.badge }}</span>
  </a>

  <a
    [attr.href]="item.url"
    (click)="itemClick($event)"
    *ngIf="(!item.routerLink || item.items) && item.visible !== false"
    (mouseenter)="onMouseEnter()"
    (keydown.enter)="itemClick($event)"
    [attr.target]="item.target"
    [attr.tabindex]="0"
    [ngClass]="item.class"
    pRipple
  >
    <app-menu-icons [iconLabel]="item.label"></app-menu-icons>
    <span class="layout-menuitem-text">{{ item.label }}</span>
    <i
      class="pi pi-fw pi-angle-down layout-submenu-toggler"
      *ngIf="item.items"
    ></i>
    <span class="menuitem-badge" *ngIf="item.badge">{{ item.badge }}</span>
  </a>
  <a
    (click)="itemClick($event)"
    (mouseenter)="hover = true"
    (mouseleave)="hover = false"
    *ngIf="item.routerLink && !item.items && item.visible !== false && !single"
    [routerLink]="!item.disabled ? item.routerLink : null"
    routerLinkActive="active-menuitem-routerlink"
    [routerLinkActiveOptions]="{ exact: !item.preventExact }"
    [attr.target]="item.target"
    [attr.tabindex]="0"
    [ngClass]="item.class"
    pRipple
    [ngClass]="{ 'disabled-menu-item': item.disabled }"
    [pTooltip]="item.disabled ? '¡Modulo no disponible!' : ''"
    tooltipPosition="top"
    tooltipEvent="focus"
  >
    <app-menu-icons [iconLabel]="item.label"></app-menu-icons>
    <span class="layout-menuitem-text">{{ item.label }}</span>
    <i
      class="pi pi-fw pi-angle-down layout-submenu-toggler"
      *ngIf="item.items"
    ></i>
    <span class="menuitem-badge" *ngIf="item.badge">{{ item.badge }}</span>
  </a>
  <ul
    *ngIf="
      ((item.items && active) ||
        (item.items && app.isStatic() && (root || active))) &&
      item.visible !== false
    "
    [@children]="
      (app.isSlim() || app.isHorizontal()) && !app.isMobile() && root
        ? active
          ? 'visible'
          : 'hidden'
        : app.isStatic() && root && !app.isMobile()
        ? 'visible'
        : active
        ? 'visibleAnimated'
        : 'hiddenAnimated'
    "
  >
    <ng-template ngFor let-child let-i="index" [ngForOf]="item.items">
      <li
        app-menuitem
        [item]="child"
        [index]="i"
        [parentKey]="key"
        [class]="child.badgeClass"
      ></li>
    </ng-template>
  </ul>
</ng-container>
